import React, {useRef} from 'react';
//@ts-ignore
import Select from 'react-select';

const CMultiFilterInput = (props: any) => {
  const {selections, allowedOptions, componentId, fieldName, placeholderStr, handleChange, isClearable, isDisabled} = props;

  // console.log('selectionsIs', selections)
  // console.log('allowed filter state is: ', allowedOptions)
  // console.log('fieldname is: ', fieldName)
  // console.log('multifilter placeholder str is: ', placeholderStr)
  // console.log("82.0-]]]] In CMultiFilterInput, props are: ", props)
  // let newRef = useRef(`${fieldName}-${componentId}`)
  // console.log("82.1-]]]] In CMultiFilterInput, useRef is: ", newRef)

  return (
    <Select
      // ref={`${fieldName}-${componentId}`}
      classNamePrefix="filter-select"
      name={fieldName}
      placeholder={placeholderStr}
      isClearable={false}
      isDisabled={true}
      isMulti
      value={selections}
      options={allowedOptions}
      onChange={(item: any, action: any) => {
        componentId ? handleChange(item, action, componentId) : handleChange(item, action);
      }}
    />
  );
};
export default CMultiFilterInput;
